// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3v8Si","boxTitle":"Qualiphy_boxTitle__1OcHX","box":"Qualiphy_box__2jX5s","toggleWrap":"Qualiphy_toggleWrap__2mXNM"};